import { useDesktopView } from 'utils/hooks/useDesktopView'

/**
 * Controls whether the desktop responsive layout is active for /ide-praktik pages.
 *
 * Driven by the Toggle SDK key 'ide-praktik-desktop-view-enabled'.
 * - false (default): always renders mobile layout
 * - true: uses actual viewport — desktop layout activates at >=768px
 */
export const useIdePraktikDesktopView = () =>
  useDesktopView('ide-praktik-desktop-view-enabled')
